module.exports = __webpack_public_path__ + "static/img/faq_service05.5981a2e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/faq_service05.png
// module id = H+OV
// module chunks = 2